<proffeo-ui-page-wrapper>
  @if (!isMobile() || !activeTask()) {
    <proffeo-task-list-toolbar
      [(viewMode)]="taskListViewMode"
      [columnManagerMenu]="taskSplitview.tableColumnManagerMenu()"
      pageActions
      class="w-full"
    />
  }

  <div
    [class.h-full]="!isMobile()"
    [class.min-h-0]="!isMobile()"
    class="flex w-full flex-col"
  >
    <proffeo-task-splitview-list
      #taskSplitview
      [viewMode]="taskListViewMode()"
      [allTasks]="tasks()"
      [isLoading]="isLoading()"
      [class.min-h-0]="!isMobile()"
      [class.flex-1]="!isMobile()"
    />
  </div>
</proffeo-ui-page-wrapper>
